import { render, staticRenderFns } from "./slider-dot.vue?vue&type=template&id=d514753a&"
import script from "./slider-dot.vue?vue&type=script&lang=js&"
export * from "./slider-dot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports